import { useState, useCallback } from 'react';
import { DocumentType, RequestMetadata } from '../types/request';
import { requesterService } from '../services/requesterService';

export const useRequestForm = (
  onSuccess: () => Promise<void>,
  setSuccess: (message: string | null) => void,
  setError: (message: string | null) => void
) => {
  const [documentType, setDocumentType] = useState<DocumentType>('pdf');
  const [metadata, setMetadata] = useState<RequestMetadata>({});
  const [aiOnly, setAiOnly] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const response = await requesterService.submitRequest(documentType, metadata, aiOnly);
      setSuccess(`Document submitted for processing! Job ID: ${response.job_id}`);
      await onSuccess();
    } catch (err) {
      setError('Failed to submit request');
    } finally {
      setLoading(false);
    }
  }, [documentType, metadata, aiOnly, onSuccess, setError, setSuccess]);

  const updateMetadata = useCallback((updates: Partial<RequestMetadata>) => {
    setMetadata(prev => ({ ...prev, ...updates }));
  }, []);

  return {
    documentType,
    setDocumentType,
    metadata,
    updateMetadata,
    aiOnly,
    setAiOnly,
    loading,
    handleSubmit,
  };
};
